import type { Route } from "./+types/$locale.contact";
import { buildSeoMeta } from "@/components/seo/meta";

export { ContactPage as default } from "@/features/support/routes/ContactPage";

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "Contact Us",
        description:
            "Get in touch with Stork Rentals for questions about baby equipment rentals, pickup locations and bookings. We're here to help.",
        path: "/contact",
        locale,
        availableLocales: [{ code: "en" }],
    });
}
